// ProductFilters.js
import React from "react";

const ProductFilters = () => {
  return (
    <div className="mb-4 flex flex-col items-center gap-4 md:flex-row">
      {/* Buscador */}
      <div className="relative w-full md:w-2/3 lg:w-1/2">
        <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          search
        </span>
        <input
          className="w-full rounded-md border border-gray-700 bg-gray-800 py-2 pl-10 pr-4 text-white placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500"
          placeholder="Buscar productos..."
        />
      </div>

      {/* Selector de categoría */}
      <div className="flex w-full flex-wrap items-center gap-2 md:w-auto">
        <select className="rounded-md border border-gray-700 bg-gray-800 px-3 py-2 text-sm text-white focus:border-primary-500 focus:ring-primary-500">
          <option>Todas las categorías</option>
          <option>Frutas</option>
          <option>Carne</option>
          <option>Panadería</option>
          <option>Lácteos</option>
        </select>
      </div>
    </div>
  );
};

export default ProductFilters;
